import {combineReducers} from 'redux';
import app from './app';
import auth from './auth'
import modal from './modal'
import shared from './shared';

const rootReducer = combineReducers({
  app,
  auth,
  modal,
  shared
})

export default rootReducer;
